import React from "react";

export function dataTableBoldText(rowData, column) {
    return boldText(rowData[column.field]);
}

export function boldText(text){
    return <span style={{fontWeight: 'bold'}}>{text}</span>;
}